import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_lot_history_report_LotHistoryBreakdownByShipment_SerialNumbersCTEService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { lotId?: number }): 
  Promise<{ result: { sumNetWeight?: number, sumGrossWeight?: number, weightUOM?: number, LicensePlateId?: number, LotId?: number, PackagingId?: number }[] }> 
  {
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_lot_history_report_LotHistoryBreakdownByShipment_SerialNumbersCTE/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { lotId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { sumNetWeight?: number, sumGrossWeight?: number, weightUOM?: number, LicensePlateId?: number, LotId?: number, PackagingId?: number }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_lot_history_report_LotHistoryBreakdownByShipment_SerialNumbersCTE/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { lotId?: number, $keys: { LicensePlateId?: number, LotId?: number, PackagingId?: number }[] }): 
  Promise<{ result: { sumNetWeight?: number, sumGrossWeight?: number, weightUOM?: number, LicensePlateId?: number, LotId?: number, PackagingId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_lot_history_report_LotHistoryBreakdownByShipment_SerialNumbersCTE/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      lotId?: number    }) {
      return false;
    }
}
